import {IOfferListOffer} from "../../../offer/types/IOfferListOffer";
import {trackAmplitudeOfferViewItemList} from "../../../tracking/amplitude/track_amplitude_offer_view_item_list";
import {PRICES_OFFERS_LIST_NAME, PricesCityAnalyticsLocation} from "./prices_city_analytics";

interface ITrackPricesCityOffersViewItemListParams {
    offers: IOfferListOffer[];
    itemListId?: string;
    location: PricesCityAnalyticsLocation;
}

export const trackPricesCityOffersViewItemList = (params: ITrackPricesCityOffersViewItemListParams) => {
    trackAmplitudeOfferViewItemList({
        offers: params.offers,
        itemListId: params.itemListId,
        itemListName: PRICES_OFFERS_LIST_NAME,
        location: params.location,
        isUspVariant: true,
        addressContext: {}
    });
};
import {IOfferListOffer} from "../../../offer/types/IOfferListOffer";
import {trackAmplitudeOfferViewItemList} from "../../../tracking/amplitude/track_amplitude_offer_view_item_list";
import {PRICES_OFFERS_LIST_NAME, PricesCityAnalyticsLocation} from "./prices_city_analytics";

interface ITrackPricesCityOffersViewItemListParams {
    offers: IOfferListOffer[];
    itemListId?: string;
    location: PricesCityAnalyticsLocation;
}

export const trackPricesCityOffersViewItemList = (params: ITrackPricesCityOffersViewItemListParams) => {
    trackAmplitudeOfferViewItemList({
        offers: params.offers,
        itemListId: params.itemListId,
        itemListName: PRICES_OFFERS_LIST_NAME,
        location: params.location,
        isUspVariant: true,
        addressContext: {}
    });
};
